import format from 'date-fns/format';

export const isFutureEvent = eventSettings => {
  const { event_date: eventDate } = eventSettings ?? {};
  const currentDate = format(new Date(), 'yy-MM-dd');
  const parsedEventDate = eventDate
    ? // Add time zone in order to prevent the wrong date from being parsed
      format(new Date(`${eventDate}T23:59:59Z`), 'yy-MM-dd')
    : '';

  if (!eventSettings) {
    return false;
  }

  return parsedEventDate > currentDate;
};
